(function () {
  'use strict';

  var nav = document.getElementById('AccessibleNav');
  if (!nav || nav.getAttribute('data-nm-fenix-header-ready') === 'true') return;

  var groups = Array.prototype.slice.call(nav.querySelectorAll('.nm-fenix-nav__item'));
  if (!groups.length) return;

  nav.setAttribute('data-nm-fenix-header-ready', 'true');

  function setOpen(group, open) {
    var trigger = group.querySelector('.nm-fenix-nav__trigger');
    var disclosure = group.querySelector('.nm-fenix-nav__disclosure');
    if (!trigger) return;

    if (disclosure) disclosure.open = open;
    group.classList.toggle('nav-hover', open);
    group.classList.toggle('nm-fenix-nav--open', open);
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeAll(except) {
    groups.forEach(function (group) {
      if (group !== except) setOpen(group, false);
    });
  }

  function markCurrentLink(group) {
    var links = group.querySelectorAll('.site-nav__dropdown a[href]');

    Array.prototype.forEach.call(links, function (link) {
      var destination;
      try {
        destination = new URL(link.getAttribute('href'), window.location.origin);
      } catch (error) {
        return;
      }

      if (destination.pathname !== window.location.pathname) return;
      if (destination.pathname === '/search') {
        var currentSearch = new URLSearchParams(window.location.search);
        if (destination.searchParams.get('q') !== currentSearch.get('q')) return;
      }

      link.setAttribute('aria-current', 'page');
      group.classList.add('site-nav--active');
    });
  }

  groups.forEach(function (group) {
    var trigger = group.querySelector('.nm-fenix-nav__trigger');
    var dropdown = group.querySelector('.site-nav__dropdown');
    var disclosure = group.querySelector('.nm-fenix-nav__disclosure');
    if (!trigger || !dropdown || !disclosure) return;

    markCurrentLink(group);

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      else event.stopPropagation();

      var shouldOpen = !disclosure.open;
      closeAll(group);
      setOpen(group, shouldOpen);
    }, true);

    group.addEventListener('mouseenter', function () {
      closeAll(group);
      setOpen(group, true);
    });

    group.addEventListener('mouseleave', function () {
      setOpen(group, false);
    });

    group.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        setOpen(group, false);
        trigger.focus();
        return;
      }

      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;

      var links = Array.prototype.slice.call(dropdown.querySelectorAll('a[href]'));
      if (!links.length) return;

      event.preventDefault();
      closeAll(group);
      setOpen(group, true);

      var currentIndex = links.indexOf(document.activeElement);
      var direction = event.key === 'ArrowDown' ? 1 : -1;
      var nextIndex = currentIndex < 0 ? (direction > 0 ? 0 : links.length - 1) : currentIndex + direction;
      if (nextIndex < 0) nextIndex = links.length - 1;
      if (nextIndex >= links.length) nextIndex = 0;
      links[nextIndex].focus();
    });

    group.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (!group.contains(document.activeElement)) setOpen(group, false);
      }, 0);
    });
  });

  document.addEventListener('click', function (event) {
    if (!nav.contains(event.target)) closeAll();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });
})();
